import classNames from 'classnames';

import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';
import { useAuth, usePhotographers, useScheduleCalendar, useUsersCalendar } from 'hooks';
import { Box, Typography } from '@material-ui/core';
import { HvSelect, HvButton, HvModal, HvPleaseWait } from 'components';
import { COLOR } from 'config/constants';
import { LOADING } from 'state/constants';
import { ScheduleCalendar, SchedulerModal } from '.';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'left',
    color: COLOR.WHITE,
    padding: 20,
    borderRadius: 8,
    overflowY: 'hidden',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 10,
  },
  control: {
    width: 200,
    marginRight: 5,
    backgroundColor: COLOR.WHITE,
    borderRadius: 8,
  },
  selectDropdown: {
    overflow: 'hidden',
  },
});

function Scheduler() {
  const intl = useIntl();
  const classes = useStyles();
  const { user, token } = useAuth();
  const { isAdmin } = user;
  const { photographers } = user.isAdmin ? usePhotographers(token) : { photographers: [] };
  const { modalType, currentDate } = useScheduleCalendar(token);
  const startDate = moment(currentDate)
    .startOf('month')
    .subtract(7, 'days')
    .format('YYYY-MM-DDTHH:mm:ss.SSSZ');
  const endDate = moment(currentDate)
    .endOf('month')
    .add(7, 'days')
    .format('YYYY-MM-DDTHH:mm:ss.SSSZ');
  const { schedule, loading } = useUsersCalendar(token, isAdmin, user.id, startDate, endDate);

  const photographerOptions = photographers.map((photographer: any) => {
    return { value: photographer.id, label: photographer.fullName };
  });
  const [selected_tech_id, setSelectedTechId] = useState<any>(null);

  const fmtFilterByTech = intl.formatMessage({ id: 'prodScheduler.filterByTech' });
  const fmtReset = intl.formatMessage({ id: 'prodScheduler.reset' });

  return (
    <Box className={classes.container}>
      {isAdmin ? (
        <div>
          <Typography variant='h5' style={{ marginBottom: 10 }}>
            {fmtFilterByTech}
          </Typography>
          {photographers.length > 0 && (
            <div className={classes.row}>
              <HvSelect
                classes={{ rootClass: classes.control, dropdownClass: classes.selectDropdown }}
                options={photographerOptions}
                value={selected_tech_id}
                onChange={(value) => {
                  setSelectedTechId(value);
                }}
              />
              <HvButton
                onClick={() => {
                  return setSelectedTechId(null);
                }}
              >
                {fmtReset}
              </HvButton>
            </div>
          )}
        </div>
      ) : null}
      {loading === LOADING.STARTED ? (
        <HvPleaseWait />
      ) : (
        <ScheduleCalendar schedule={schedule} selected_tech_id={selected_tech_id} />
      )}
      {modalType && (
        <SchedulerModal schedule={schedule} photographerOptions={photographerOptions} />
      )}
    </Box>
  );
}

export default Scheduler;
